import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './Menu.module.scss';

interface MenuProps {
  type?: string;
  arrow?: boolean;
  popup?: boolean;
  shaded?: boolean;
  bordered?: boolean;
  className?: string;
  fullWidth?: boolean;
  verticalPosition?: 'Below' | 'Above';
  horizontalPosition?: 'Left' | 'Right' | 'Center';
}

export class Menu extends Component<MenuProps> {
  static defaultProps = {
    arrow: true,
    popup: false,
    shaded: false,
    bordered: false,
    fullWidth: false,
    verticalPosition: 'Below',
    horizontalPosition: 'Center',
  };

  render() {
    const {
      arrow,
      popup,
      shaded,
      bordered,
      children,
      className,
      fullWidth,
      verticalPosition,
      horizontalPosition,
    } = this.props;

    const classes = classNames(className, {
      [styles.menu]: true,
      [styles.popup]: popup,
      [styles.arrow]: arrow,
      [styles.shaded]: shaded,
      [styles.bordered]: bordered || popup,
      [styles.fullWidth]: fullWidth,
      [styles[`verticalPosition${verticalPosition}`]]: popup,
      [styles[`horizontalPosition${horizontalPosition}`]]: popup,
    });

    return <ul className={classes}>{children}</ul>;
  }
}

export default Menu;
